import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Circle } from '@tink/core/src/components/atoms/Circle/Circle';
import { Box } from '@tink/core/src/components/atoms/Box/Box';
import { Lock } from '@tink/core/src/components/atoms/Icons/Lock';
import { ProviderEntity } from '../../../../../../../../models/provider';
import { PageView } from '../../../../../../../../models/analytics';
import { Button } from '../../../../../../../../components/atoms/Button/Button';
import { Header } from '../../../../../../../../components/organisms/Header/Header';
import { ScreenWrapper } from '../../../../../../../../components/atoms/ScreenWrapper/ScreenWrapper';
import { ContentBody } from '../../../../../../../../components/atoms/ContentBody/ContentBody';
import { Stack } from '../../../../../../../../components/atoms/Stack/Stack';
import { LegalDisclaimer } from '../../../../../../../../components/molecules/LegalDisclaimer/LegalDisclaimer';
import { Text } from '../../../../../../../../components/atoms/Text/Text';
import { commonMessages } from '../../../../../../../../components/atoms/CommonMessages/messages';
import { messages } from './messages';

type DesktopViewProps = {
  provider: ProviderEntity;
  onBack: () => void;
  onClick: () => void;
};

export const SubmitCredentialsScreenBankIDDesktopView: React.FC<DesktopViewProps> = ({
  provider,
  onBack,
  onClick,
}) => {
  return (
    <ScreenWrapper data-testid="submit-credentials-screen-bankid-desktop">
      <Header
        addBottomMargin={false}
        onBack={onBack}
        hideCloseButton
        pageView={PageView.SUBMIT_CREDENTIALS_SCREEN_BANKID}
      />

      <ContentBody>
        <Stack justifyContent="center" alignItems="center">
          <Circle size="xlarge" color="primary" shade="200">
            <Lock color="primary" />
          </Circle>
          <Box px="xlarge" textAlign="center">
            <Text>
              <FormattedMessage {...messages.desktopInstructions} />
            </Text>
          </Box>
        </Stack>
        <Button color="primary" onClick={onClick} variant="contained">
          <FormattedMessage {...commonMessages.continue} />
        </Button>
      </ContentBody>
      <LegalDisclaimer provider={provider} pageView={PageView.SUBMIT_CREDENTIALS_SCREEN_BANKID} />
    </ScreenWrapper>
  );
};
